// settings/HamburgerMenu/SidebarLayout.tsx
import React, { useEffect, useRef, useState } from "react";
import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { isSettingOpenAtom, isReceptionAtom } from "~/Atom";
import { SidebarLayoutProps } from "shared/Schemas";

/**
 * サイドバーのレイアウトを管理するコンポーネント
 * スクロール状態に応じてスタイルを変更する
 */
const SidebarLayout: React.FC<SidebarLayoutProps> = ({ children, pageMode = false }) => {
  const { t } = useTranslation();
  const [isSettingOpen] = useAtom(isSettingOpenAtom);
  const [isReception] = useAtom(isReceptionAtom);
  const menuRef = useRef<HTMLDivElement>(null);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    /**
     * スクロールイベントのハンドラー
     * スクロール位置に応じてスタイルを切り替える
     */
    const handleScroll = () => {
      if (menuRef.current) {
        setIsScrolled(menuRef.current.scrollTop > 0);
      }
    };

    const menuContent = menuRef.current;
    if (menuContent) {
      menuContent.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (menuContent) {
        menuContent.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  // スクロール状態に応じたクラス名を生成
  const trackClassName = isScrolled ? "active-track" : "default-track";
  const openClassName = isSettingOpen && !pageMode ? "open" : "";
  const pageModeClassName = pageMode ? "page-mode" : "";
  const receptionContentClassName = isReception ? "menu-content-reception" : "";
  const receptionTitleClassName = isReception ? "setting-title-reception" : "";

  return (
    <div
      ref={menuRef}
      className={`menu-content ${openClassName} ${trackClassName} ${pageModeClassName} ${receptionContentClassName}`}
    >
      {!pageMode && (
        <div className={`setting-title font-default-bold-24 ${receptionTitleClassName}`}>
          {t("settings")}
        </div>
      )}
      {children}
    </div>
  );
};

export default SidebarLayout;
